<template>
  <div>
    <v-container>
      <v-card flat class="futuristic-card">
        <div class="card-header">
          <h1 class="earth-color" v-if="route === 'NewVolunteerProgram'">ADD NEW IMMERSIVE CONSERVATION EXPERIENCE PROGRAM</h1>
          <h1 class="earth-color" v-else>UPDATE IMMERSIVE CONSERVATION EXPERIENCE PROGRAM</h1>
          <div class="title-decoration"></div>
        </div>
        <v-container>
          <v-form @submit.prevent="addProgram()">
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Program Name"
                  v-model="program.name"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <label class="futuristic-label">Program Description</label>
                <vue-editor v-model="program.desc" class="futuristic-editor"></vue-editor>
              </v-container>
            </v-flex>
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-dialog
                    ref="dialog"
                    persistent
                    v-model="modal1"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="program.start_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="Start Date"
                      v-model="program.start_date"
                      readonly
                      class="futuristic-input"
                    ></v-text-field>
                    <v-date-picker
                      v-model="program.start_date"
                      scrollable
                      :min="today"
                      class="futuristic-datepicker"
                    >
                      <v-spacer></v-spacer>
                      <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                      <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(program.start_date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-dialog
                    ref="dialog1"
                    persistent
                    v-model="modal2"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="program.end_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="End Date"
                      v-model="program.end_date"
                      readonly
                      class="futuristic-input"
                    ></v-text-field>
                    <v-date-picker
                      v-model="program.end_date"
                      scrollable
                      :min="program.start_date"
                      class="futuristic-datepicker"
                    >
                      <v-spacer></v-spacer>
                      <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                      <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(program.end_date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container fluid>
                  <v-autocomplete
                    label="Currency"
                    v-model="program.currency"
                    :items="allCurrencies"
                    :rules="[v => !!v || 'Item is required']"
                    required
                    item-text="currency_name"
                    item-value="currency_public_id"
                    :loading="$loadingTrue"
                    class="futuristic-input"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Price"
                    v-model="program.price"
                    :rules="requiredRules"
                    required
                    min="0"
                    type="number"
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Max Applicants"
                    v-model="program.max_applicants"
                    :rules="requiredRules"
                    required
                    min="0"
                    type="number"
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
            </v-layout>
            <v-container>
              <v-btn :depressed="true" color="primary" block type="submit" v-if="route === 'NewVolunteerProgram'" class="futuristic-btn">Add Program</v-btn>
              <v-btn :depressed="true" color="warning" block type="submit" v-if="route === 'EditProgram'" class="futuristic-btn">Update Program</v-btn>
            </v-container>
          </v-form>
        </v-container>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">IMMERSIVE CONSERVATION EXPERIENCE PROGRAM</h1>
              <div class="title-decoration"></div>
            </div>
            <v-card-text>
              <div class="table-responsive futuristic-table-container">
                <table class="futuristic-table">
                  <thead>
                    <tr>
                      <th class="table-header">Name</th>
                      <th class="table-header">Description</th>
                      <th class="table-header">Start Date</th>
                      <th class="table-header">End Date</th>
                      <th class="table-header">Price</th>
                      <th class="table-header">Max Applicants</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(program, key) in programs_data.programs" :key="key">
                      <td>{{program.name}}</td>
                      <td>{{program.desc}}</td>
                      <td>{{$moment(program.start_date).format('Do MMMM YYYY')}}</td>
                      <td>{{$moment(program.end_date).format('Do MMMM YYYY')}}</td>
                      <td v-if="program.currency === '162fface-f5f1-41de-913b-d2bb784dda3a'">KES {{program.price}}</td>
                      <td v-if="program.currency === '6bf74e49-7ff6-4555-a080-15541d62204a'">USD {{program.price}}</td>
                      <td>{{program.max_applicants}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <v-container class="text-xs-right">
                <v-btn :depressed="true" color="error" type="submit" @click.prevent="resetProgram()" v-if="edit === false && programs_data.programs.length > 0" class="futuristic-btn">Reset Program</v-btn>
                <v-btn :depressed="true" :loading="this.$store.state.LoadingStore.loading" color="info" type="submit" @click.prevent="postProgram()" v-if="edit === false && programs_data.programs.length > 0" class="futuristic-btn">Post Program</v-btn>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card>
      {{updateProgram}}
    </v-container>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import HotelDatePicker from 'vue-hotel-datepicker'
import Facility from '../../../mixins/Computed/Facility/FacilityVuex'
import ProgramVuex from '../../../mixins/Computed/Volunteer/ProgramsVuex'
import Currency from '../../../mixins/Computed/Finance/CurrencyVuex'
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'new-volunteer-program',
  components: {
    HotelDatePicker,
    Datepicker,
    VueEditor
  },
  data () {
    return {
      today: this.$moment().format('YYYY-MM-DD'),
      route: this.$route.name,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      date_settings: {
        night: 'Day',
        nights: 'Days',
        'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
        'check-in': 'Start-Date',
        'check-out': 'End-Date',
        'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      
      programs_data: {
        programs:[]
      },
      program: {
        public_id: '',
        start_date: '',
        end_date: '',
        currency: '',
        desc: 'No Description',
        name: '',
        price: '',
        max_applicants: '',
        room_id: '',
        session: localStorage.getItem('lkjhgfdsa')
      },
      edit: false,
    }
  },
  created () {
    if (this.$route.name === 'EditProgram') {
      this.$store.dispatch('get_program', this.$route.params.program_id)
    }
    this.$store.dispatch('get_all_currencies')
  },
  methods: {
    putStartDate: function () {
      var date = this.program.start_date
      date = this.$moment(date).format('YYYY-MM-DD')
      this.program.start_date = date
    },
    putEndtDate: function () {
      var date = this.program.end_date
      date = this.$moment(date).format('YYYY-MM-DD')
      this.program.end_date = date
    },
     addProgram: function () {
       let data = {
        start_date: this.program.start_date,
        end_date: this.program.end_date,
        currency: this.program.currency,
        desc: this.program.desc,
        name: this.program.name,
        price: this.program.price,
        max_applicants: this.program.max_applicants,
        session: this.program.session,
      }
      this.programs_data.programs.push(data)
    },
    postProgram: function () {
      if (this.route === 'NewVolunteerProgram') {
        this.$store.dispatch('post_program', this.programs_data)
      } else {
        this.$store.dispatch('update_program', this.program)
      }
    },
      resetProgram: function() {
      this.program = {
        public_id: '',
        start_date: '',
        end_date: '',
        currency: '',
        desc: 'No Description',
        name: '',
        price: '',
        max_applicants: '',
        room_id: '',
        session: localStorage.getItem('lkjhgfdsa')
      },
      this.programs_data.programs =[]

    },
  },
  computed: {
    disabled_settings: function () {
      var startDate = this.$moment().format('YYYY-MM-DD')
      return {
        to: new Date(this.$moment(startDate).format('YYYY, MM, DD'))
      }
    }
  },
  mixins: [Facility, ProgramVuex, Currency]
}
</script>

<style scoped>
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 16px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 8px;
  width: 100px;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 0 12px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
}

.futuristic-input >>> .v-text-field__details {
  padding: 4px 12px;
}

.futuristic-label {
  color: #587e27;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
}

.futuristic-editor {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.futuristic-editor >>> .quill-wrapper {
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px;
}

.futuristic-datepicker {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.futuristic-btn {
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.futuristic-table-container {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
}

.futuristic-table th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  padding: 12px 16px;
  text-align: left;
}

.futuristic-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .search-container {
    padding: 8px;
  }
  
  .futuristic-table {
    display: block;
    overflow-x: auto;
  }
}
</style>